import { ChangeDetectorRef, Component } from '@angular/core';
import { environment } from '../../../environment/environment';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear!: number;

  customerName = environment.customerName;
  constructor(private cdRef: ChangeDetectorRef) { }
  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.cdRef.detectChanges();
  }
}
